import { render, staticRenderFns } from "./ProfileInfo.vue?vue&type=template&id=2508532e&scoped=true"
import script from "./ProfileInfo.vue?vue&type=script&lang=js"
export * from "./ProfileInfo.vue?vue&type=script&lang=js"
import style0 from "./ProfileInfo.vue?vue&type=style&index=0&id=2508532e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2508532e",
  null
  
)

export default component.exports